export const getTilesGridStyle = () => ({
  tilesGridContainer: {
    // grid styles
    '& .tiles-grid': {
      overflow: 'hidden',
      position: 'relative',
      '& .ms-List-page': {
        overflowX: 'hidden',
      },
    },

    '& .tiles-grid-list-cell': {
      float: 'left', // make the cells shown as grid style
    },

    // cell styles
    '& .tiles-grid-cell': {
      position: 'relative',
      boxSizing: 'border-box',
      width: '100%',
      height: '100%',
    },
  },
});
